/**
 * The five-card ladder, weakest first — the array order IS the strength order,
 * so a straight flush beats quads beats a full house beats a flush beats a
 * straight regardless of the cards in them.
 */
export const FIVE_KINDS = ['straight', 'flush', 'fullhouse', 'quads', 'straightflush'];
//# sourceMappingURL=types.js.map